module.exports = {
  returnName: {
    Lote: 'Lote',
    Manual: 'Manual',
    Transferencia: 'Transferencia',
  },
  returnNameFormatted: {
    Lote: 'Lote',
    Manual: 'Manual',
    Transferencia: 'Transferência',
  },
  returnNameForNameFormatted: {
    Lote: 'Lote',
    Manual: 'Manual',
    Transferência: 'Transferencia',
  },
  returnId: {
    Lote: 1,
    Manual: 2,
    Transferência: 3
  }
};
